import { type IClientProviderPluginInstaller, type ClientProviderPluginInstallOption } from '../models/plugin-type'
import { type IClientProviderPlugin } from '@source-digital/sd-app-core'
import { BaseClientProviderPluginInstaller } from '../base'
import { type IBrokerContext } from '../../context'
import { nanoid } from 'nanoid'
import { type ClientPlugin } from '@source-digital/sd-app-client-core'
import { createScriptProviderPlugin } from '@source-digital/sd-app-client-adapter-script'

export interface LocalClientPluginInstallOption extends ClientProviderPluginInstallOption<'local'> {
  clientProviderPlugin?: IClientProviderPlugin
  clientPlugin?: ClientPlugin
}

export class LocalClientProviderPluginInstaller extends BaseClientProviderPluginInstaller implements IClientProviderPluginInstaller<'local', LocalClientPluginInstallOption> {
  constructor (ctx: IBrokerContext) {
    super(ctx, 'ScriptClientProviderPluginInstaller')
  }

  #getPlugin (installOption: LocalClientPluginInstallOption): IClientProviderPlugin {
    if (installOption.clientProviderPlugin != null) {
      return installOption.clientProviderPlugin
    } else if (installOption.clientPlugin != null) {
      return createScriptProviderPlugin(installOption.clientPlugin)
    } else {
      throw new Error('clientProviderPlugin or clientPlugin must be provided.')
    }
  }

  async install (installOption: LocalClientPluginInstallOption): Promise<{ id: string, name?: string, plugin: IClientProviderPlugin }> {
    const { name } = installOption
    const clientProviderPlugin = this.#getPlugin(installOption)
    const id = `local-${nanoid()}`
    await clientProviderPlugin.install(this.createContext(clientProviderPlugin, id))
    this.logger.log('Installed client plugin.', installOption)
    return {
      id,
      name,
      plugin: clientProviderPlugin
    }
  }

  async uninstall (module: IClientProviderPlugin): Promise<void> {
    await module.uninstall()
  }
}
